import React from 'react';
import SignerRouter from '../SignerRouter';
import SignerTopBar from './SignerTopbar';
// import {
//   onAuthUIStateChange
// } from '@aws-amplify/ui-components';

const SignerComponent = () => {
  return (
    <>
      <SignerTopBar />
      <SignerRouter />

    </>
  );
};
export default SignerComponent;
